import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/index.vue'
Vue.use(VueRouter)


const Routers = [{
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            title: '首页'
        },
        children: []
    },
    {
        // path: '/',
        path: '/ShanDongNews',
        name: 'ShanDongNews',
        meta: {
            title: '看山东'
        },
        component: (resolve) => require(['@/views/ShanDongNews.vue'], resolve),
    },
    {
        path: '/articleList',
        name: 'articleList',
        meta: {
            title: '看山东'
        },
        component: (resolve) => require(['@/views/ArticleList.vue'], resolve),
    },

    {
        path: '/article',
        name: 'article',
        meta: {
            title: '新闻详情'
        },
        component: (resolve) => require(['@/views/NewsContent.vue'], resolve),
    },
    {
        // path: '/',
        path: '/ComplainOnline',
        name: 'ComplainOnline',
        meta: {
            title: '在线投诉页面'
        },
        component: (resolve) => require(['@/views/ComplainOnline.vue'], resolve),
    },
    {
        // path: '/',
        path: '/ComplainView',
        name: 'ComplainView',
        meta: {
            title: '新闻列表'
        },
        component: (resolve) => require(['@/views/ComplainViewList.vue'], resolve),
    },
    {
        // path: '/',
        path: '/HeaderNewsList',
        name: 'HeaderNewsList',
        meta: {
            title: '新闻列表'
        },
        component: (resolve) => require(['@/views/HeaderNewsList.vue'], resolve),
    },
    {
        // path: '/',
        path: '/complainInfo',
        name: 'complainInfo',
        meta: {
            title: '投诉类新闻详情'
        },
        component: (resolve) => require(['@/views/ComplainDetail.vue'], resolve),
    },
    {
        // path: '/',
        path: '/PersonCenter',
        name: 'PersonCenter',
        meta: {
            title: '个人中心'
        },

        component: (resolve) => require(['@/views/PersonCenter.vue', ], resolve),
    },
    {
        // path: '/',
        path: '/ComplainCenter',
        name: 'ComplainCenter',
        meta: {
            title: '投诉和和解中心'
        },
        component: (resolve) => require(['@/views/ComplainCenter.vue'], resolve),
    },
    {
        // path: '/',
        path: '/ComplainContent',
        name: 'ComplainContent',
        meta: {
            title: '投诉详情'
        },
        component: (resolve) => require(['@/views/ComplainContent.vue'], resolve),
    },
    {
        // path: '/',
        path: '/aboutWeb',
        name: 'aboutWeb',
        meta: {
            title: '网站介绍'
        },
        component: (resolve) => require(['@/views/aboutWeb.vue'], resolve),
    },

    {
        // path: '/',
        path: '/advertising',
        name: 'advertising',
        meta: {
            title: '广告报价'
        },
        component: (resolve) => require(['@/views/advertising.vue'], resolve),
    },
    {
        // path: '/',
        path: '/HejieDaren',
        name: 'HejieDaren',
        meta: {
            title: ''
        },
        component: (resolve) => require(['@/views/HejieDaren.vue'], resolve),
    }
]

const RouterConfig = {
    // mode: 'history',
    mode: 'hash',
    routes: Routers
}
const router = new VueRouter(RouterConfig)
router.beforeEach((to, from, next) => {
    let href = window.location.href
    // alert(href)
    if (href.includes('/?/')) {
        window.location.href = href.replace('/?/', '/#/')
        return true
    }
    // 判断该路由是否需要登录权限
    if (to.matched.some(record => record.meta.requireAuth)) {
        // 判断当前的token是否存在 ，登录存入的token
        if (localStorage.getItem('token')) {
            next()
        } else {
            next({
                path: '/login',
                // 将跳转的路由path作为参数，登录成功后跳转到该路由
                query: { redirect: to.fullPath }
            })
        }
    } else {
        next()
    }
})
router.afterEach(() => {
    window.scrollTo(0, 0)
})

export default router